export const contractTypeIcon = require(`@src/assets/images/icons/info-suitcase.svg`).default;
export const contractTypeIcon2 = require(`@src/assets/images/icons/info-suitcase-2.svg`).default;

export const activeIcon = require(`@src/assets/images/icons/icon-verified.svg`).default;

export const onlineIcon = require(`@src/assets/images/icons/online.svg`).default;

export const lockedIcon = require(`@src/assets/images/icons/icon-locked.svg`).default;

export const greenLock = require(`@src/assets/images/icons/green-lock.svg`).default;


export const mapIcon = require(`@src/assets/images/icons/info-mappin.svg`).default;

export const noVideoCVIcon = require(`@src/assets/images/icons/no-video-cv.svg`).default;

export const GreenCheckIcon = ({ size, className = '' }) => {
  const url = require("@src/assets/images/icons/icon-green-check-filled.svg").default;

  return <img src={url} alt="green check icon" width={size} height={size} className={className} />;
};

export const greenCheck = require(`@src/assets/images/icons/icon-green-check-filled.svg`).default;

export const companyIcon = require("@src/assets/images/icons/icon-company.svg").default;

export const contactInfoIcon = require("@src/assets/images/icons/icon-contact-info.svg").default;

export const envIcon = require("@src/assets/images/icons/icon-environment.svg").default;

export const confirmUnlockIcon = require("@src/assets/images/icons/icon-unlock.svg").default;

export const payToUnlockIcon = require("@src/assets/images/icons/icon-pay-to-unlock.svg").default;

export const paymentSuccessfulIcon = require(`@src/assets/images/icons/icon-payment-success.png`);

export const paymentFailedIcon = require(`@src/assets/images/icons/icon-upset.svg`).default;

export const blockedIcon2 = require(`@src/assets/images/icons/icon-blocked-2.svg`).default;

export const buildingIcon = require("@src/assets/images/icons/icon-building.svg").default;

export const ksaFlagIcon = require("@src/assets/images/icons/icon-ksa-flag.svg").default;

export const warningIcon = require("@src/assets/images/icons/icon-wanring.svg").default;

export const crossMarkIcon = require("@src/assets/images/icons/icon-crossmark.svg").default;

export const creditCardIcon = require("@src/assets/images/icons/icon-credit-cards.svg").default;

export const downloadAppBanner = require("@src/assets/images/pages/download-app-banner.png");

export const appQRCode = require("@src/assets/images/pages/qr-code.png");

export const googlePlayStoreIcon = require("@src/assets/images/pages/google-playstore.svg").default;

export const appStoreIcon = require("@src/assets/images/pages/app-store.svg").default;

export const moneyIconSmall = require("@src/assets/images/icons/money-small.svg").default;

export const hurrayIcon = require("@src/assets/images/icons/icon-hurray.svg").default;

export const orangeGlobeIcon = require("@src/assets/images/icons/globe-orange.svg").default;

export const whatsAppIcon = require("@src/assets/images/icons/WA-logo.svg").default;

export const storeIcon = require("@src/assets/images/icons/store.png");

export const blockedIcon = require("@src/assets/images/icons/icon-blocked.svg").default;

export const bulbIcon = require("@src/assets/images/icons/icon-bulb.svg").default;

export const ministryVerificationIcon = require("@src/assets/images/icons/ministry-verification-icon.png");

export const jobPostConfirmationIcon = require("@src/assets/images/icons/job-post-confirmation-icon.svg").default;

export const orangeAvatar = require("@src/assets/images/icons/orange-avatar.svg").default;

export const verifiedIcon = require("@src/assets/images/icons/verified-orange-icon.svg").default;

export const backLeft = require("@src/assets/images/icons/back-left.png");

export const backRight = require("@src/assets/images/icons/back-right.png");

export const whatsAppIconOrange = require("@src/assets/images/icons/icon-whatsapp.svg").default;

export const sabbarLogoOrange = require('@src/assets/images/logo/sabbar-logo.jpg')

export const invoiceIcon = require("@src/assets/images/icons/invoice-icon.png");

export const noImageIcon = require("@src/assets/images/icons/no-image.png");

export const companyProfileIcon = require("@src/assets/images/icons/office-building.svg").default;

export const maleDefaultAvatar = require("@src/assets/images/icons/male-default-avatar.svg").default;

export const femaleDefaultAvatar = require("@src/assets/images/icons/female-default-avatar.svg").default;

export const jobsIcon = require("@src/assets/images/icons/briefcase.svg").default;

export const buildingIcon2 = require("@src/assets/images/icons/icon-building-2.svg").default;

export const jobSeekerIcon = require("@src/assets/images/icons/icon-job-seeker.svg").default;

export const largeImageSizeIcon = require("@src/assets/images/icons/icon-file-large-size.png");

export const sittingAloneIcon = require("@src/assets/images/icons/icon-sitting-alone.png");

export const infoPurpleIcon = require("@src/assets/images/icons/info-purple.svg").default;

export const promoteIcon = require("@src/assets/images/icons/promote-icon.png");

export const whiteBulbIcon = require("@src/assets/images/icons/icon-light-bulb-white.svg").default;

export const educationLogo = require("@src/assets/images/logo/moe-logo.png");

export const emailOrangeIcon = require("@src/assets/images/icons/email-orange.svg").default;

export const emailSuccessIcon = require("@src/assets/images/icons/email-success.svg").default;

export const filterAdjustmentIcon = require('@src/assets/images/icons/icon-filter-adjustments.svg').default

export const noWorkersFoundImage = require("@src/assets/images/icons/sabbar-searching.svg").default;

export const iconCloseFilled = require('@src/assets/images/icons/icon-close-filled.svg').default;
export const infoCircleRed = require('@src/assets/images/icons/info-circle-red.svg').default;

export const iconStar = require('@src/assets/images/icons/star.svg').default;

export const paginationRight = require("@src/assets/images/icons/pagination-right.png");

export const paginationLeft = require("@src/assets/images/icons/pagination-left.png");

export const iconPlay = require("@src/assets/images/icons/icon-play.png");

export const greyRightIcon = require("@src/assets/images/icons/grey-right.png");

export const greyLeftIcon = require("@src/assets/images/icons/grey-left.png");

export const emptyVideoPlaceholder = require("@src/assets/images/icons/empty-placeholder.png");

export const darkClose = require("@src/assets/images/icons/x.svg").default;

export const iconCheckGreen = require("@src/assets/images/icons/icon-check-circle-filled.svg").default;

export const iconCheckDarkGreen = require("@src/assets/images/icons/dark-green-check.svg").default;

export const iconChat = require("@src/assets/images/icons/icon-chat.svg").default;

export const contractIcon = require("@src/assets/images/icons/jp-contract.svg").default;

export const workplaceIcon = require("@src/assets/images/icons/jp-workplace.svg").default;

export const salaryIcon = require("@src/assets/images/icons/jp-salary.svg").default;

export const descriptionIcon = require("@src/assets/images/icons/jp-description.svg").default;

export const locationIcon = require("@src/assets/images/icons/jp-location.svg").default;

export const notFoundImage = require("@src/assets/images/pages/not-found.svg").default;

export const iconApplicantsCardSlidersEn = require("@src/assets/images/pages/job-seeker-cards.gif");

export const iconApplicantsCardSlidersAr = require("@src/assets/images/pages/job-seeker-cards-ar.gif");

export const pendingIcon = require("@src/assets/images/icons/illustration-pending-info.svg").default;

export const pendingGreyIcon = require("@src/assets/images/icons/illustration-grey.svg").default;

export const phoneIcon = require("@src/assets/images/icons/icon-phone.svg").default;

export const jobsIcon2 = require("@src/assets/images/icons/jobs-icon.svg").default;

export const freeJobPostIcon = require("@src/assets/images/icons/icon-free-post.png");

export const freeJobPostIcon2 = require("@src/assets/images/icons/icon-free-post-2.png");

export const jobsGrayIcon = require("@src/assets/images/icons/briefcase-gray.svg").default;

export const companyProfileGrayIcon = require("@src/assets/images/icons/office-building-gray.svg").default;

export const appleIcon = require("@src/assets/images/icons/apple-icon.png");

export const ccMethodIcon = require("@src/assets/images/icons/icon-credit-cards-2.png");

export const applePayMethodIcon = require("@src/assets/images/icons/apple-pay-logo-icon.png");

export const diplomaLogo = require("@src/assets/images/icons/icon-education.svg").default;

export const phoneIconOrange = require("@src/assets/images/icons/icon-phone-orange.svg").default;

export const discountIcon = require("@src/assets/images/icons/icon-discount.svg").default;

export const campaignIcon1 = require("@src/assets/images/icons/campaign-icon-1.svg").default;

export const campaignIcon2 = require("@src/assets/images/icons/campaign-icon-2.svg").default;

export const endOfYearIcon = require("@src/assets/images/icons/end-of-year.svg").default;

export const nationalOffer = require("@src/assets/images/icons/national-popup.png");

export const sabbarEmployerLogo = require("@src/assets/images/logo/sabbar-new-logo-ar.png");

export const bankTransferIcon = require("@src/assets/images/icons/icon-bank-payment.svg").default;

export const dollarIcon = require("@src/assets/images/icons/icon-dollar.svg").default;

export const documentIcon = require("@src/assets/images/icons/icon-document.svg").default;

export const alinmaBankLogo = require("@src/assets/images/logo/alinma-bank-logo.svg").default;

export const iconMoney = require("@src/assets/images/icons/icon-money.svg").default;

export const sabbarLogo = require('@src/assets/images/logo/sabbar-logo.svg').default;

export const jobSeekerIcon1 = require('@src/assets/images/icons/icon_jobseeker_1.svg').default;

export const jobSeekerIcon2 = require('@src/assets/images/icons/icon_jobseeker_2.svg').default;

export const jobSeekerIcon3 = require('@src/assets/images/icons/icon_jobseeker_3.svg').default;

export const upArrowOrangeIcon = require('@src/assets/images/icons/icon-up.svg').default;

export const iconChatBlack = require("@src/assets/images/icons/icon-chat-black.svg").default;

export const whatsAppIconGray = require("@src/assets/images/icons/icon-whatsapp-gray.svg").default;

export const historyIconGray = require("@src/assets/images/icons/icon-history.svg").default;

export const creditCardVector = require("@src/assets/images/icons/icon-credit card.svg").default;

export const thumbsUpIcon = require("@src/assets/images/icons/icon-thumbs-up.svg").default;

export const thumbsDownIcon = require("@src/assets/images/icons/icon-thumbs-down.svg").default;

export const chatIcon = require("@src/assets/images/icons/chat-icon.svg").default;

export const cameraIcon = require("@src/assets/images/icons/icon-camera.svg").default;

export const documentIcon2 = require("@src/assets/images/icons/icon-document-2.svg").default;

export const iconMessageRead = require("@src/assets/images/icons/icon-message-read.svg").default;

export const chatIconGray = require("@src/assets/images/icons/chat-icon-gray.svg").default;

export const iconJob = require("@src/assets/images/icons/icon-job.svg").default;

export const iconJobs = require("@src/assets/images/icons/icon-jobs.svg").default;

export const iconMoneyBag = require("@src/assets/images/icons/icon-money-bag.png");

export const iconFire = require("@src/assets/images/icons/icon-fire.png");

export const iconChatMessages = require("@src/assets/images/icons/icon-chat-messages.svg").default;

export const iconHelp = require("@src/assets/images/icons/icon-help.svg").default;

export const recommendedIcon = require("@src/assets/images/icons/icon-recommended.svg").default;

export const iconFireVector = require("@src/assets/images/icons/icon-fire.svg").default;

export const iconNoApplicants = require("@src/assets/images/icons/icon-no-applicants.png");

export const iconNew = require("@src/assets/images/icons/icon-sparkles.svg").default;

export const mtLogo = require("@src/assets/images/logo/ministry-of-tourism-logo.svg").default;

export const iconOrganization = require("@src/assets/images/icons/icon-organization.svg").default;

export const iconAuthourizedPerson = require("@src/assets/images/icons/icon-authourized-person.svg").default;

export const iconVerifiedJob = require("@src/assets/images/icons/icon-verified-job.svg").default;

export const iconAccountActivation = require("@src/assets/images/icons/icon-account-activation.svg").default;

export const iconAccountPendingReview = require("@src/assets/images/icons/icon-account-pending-review.svg").default;

export const logoMHRSD = require("@src/assets/images/icons/mhrsd-logo.svg").default;

export const jobSeekersIcon = require('@src/assets/images/icons/icon-job-seekers.png');

export const blurredCvIcon = require('@src/assets/images/icons/blurred-cv.png');

export const iconFireTGVector = require("@src/assets/images/icons/icon-fire-turquoise.svg").default;

export const iconStudent = require("@src/assets/images/icons/icon-student.svg").default;

export const recommendedIconPurple = require("@src/assets/images/icons/icon-recommended-purple.svg").default;

export const suggestedIcon = require("@src/assets/images/icons/suggested-icon.svg").default;

export const suggestedLoading = require("@src/assets/images/icons/suggested-loading.svg").default;

export const iconArticle = require("@src/assets/images/icons/icon-article.svg").default;

export const iconPlatForm = require("@src/assets/images/icons/icon-platform.svg").default;

export const iconCheckedTG = require("@src/assets/images/icons/icon-check-circle-filled-tg.svg").default;

export const iconLightningBolt = require("@src/assets/images/icons/icon-lightning-bolt.svg").default;

export const iconBriefcaseTG = require("@src/assets/images/icons/info-briefcase-tg.svg").default;

export const iconCurrencyDollarTG = require("@src/assets/images/icons/icon-currency-dollar-tg.svg").default;

export const iconLocationTG = require("@src/assets/images/icons/icon-location-marker-tg.svg").default;

export const recommendationCardsEN = require("@src/assets/images/pages/recommendations-en.gif");

export const recommendationCardsAR = require("@src/assets/images/pages/recommendations-ar.gif");

export const iconNoMessages = require("@src/assets/images/icons/icon-chat-no-message.svg").default;

export const iconTime = require('@src/assets/images/icons/icon-time.svg').default;

export const greyClockIcon = require('@src/assets/images/icons/grey-clock.svg').default;

export const iconCostEffective = require('@src/assets/images/icons/icon-cost-effective.svg').default;

export const iconDownload2 = require('@src/assets/images/icons/icon-download-2.svg').default;

export const iconLock2 = require('@src/assets/images/icons/icon-lock-2.svg').default;

export const askToUploadIcon = require('@src/assets/images/icons/ask-upload-icon.svg').default;

export const askToUploadIcon2 = require('@src/assets/images/icons/ask-to-upload.png');

export const appQr = require('@src/assets/images/icons/sabbar-qr-download.png');

export const smallMobileIcon = require('@src/assets/images/icons/small-mobile.svg').default;

export const playStoreSmIcon = require('@src/assets/images/icons/play-store-icon-sm.svg').default;

export const appStoreSmIcon = require('@src/assets/images/icons/app-store-icon-sm.svg').default;

export const reopenJobIcon = require('@src/assets/images/icons/reopen-job.svg').default;

export const browserGeneric = require('@src/assets/images/icons/browser-icons/generic-1.png');
export const browserChrome = require('@src/assets/images/icons/browser-icons/chrome.png');
export const browserEdge = require('@src/assets/images/icons/browser-icons/edge.png');
export const browserFirefox = require('@src/assets/images/icons/browser-icons/firefox.png');
export const browserSafari = require('@src/assets/images/icons/browser-icons/safari.png');
export const browserSabbar = require('@src/assets/images/icons/browser-icons/sabbar.png');

export const companiesApp = require('@src/assets/images/icons/companies-app-1.png');

export const cvSearchIcon = require('@src/assets/images/icons/cv-search-icon.svg').default;
export const cvSearchPlaceholder = require('@src/assets/images/icons/cv-search-placeholder.png');
export const cvSearchBg = require('@src/assets/images/icons/cv-search-bg.png');
export const cvSearchVideoIcon = require('@src/assets/images/icons/video-icon.svg').default;
export const cvSearchSkillsIcon = require('@src/assets/images/icons/skills-icon.svg').default;
export const cvSearchJobIcon = require('@src/assets/images/icons/job-title-icon.svg').default;
export const cvSearchEducationIcon = require('@src/assets/images/icons/education-icon.svg').default;
export const cvSearchNewFeatureIcon = require('@src/assets/images/icons/cv-search-new-feature.png');
export const doubleChevronLeftIcon = require('@src/assets/images/icons/chevron-double-left.png');
export const doubleChevronRightIcon = require('@src/assets/images/icons/chevron-double-right.png');
export const doubleChevronUpIcon = require('@src/assets/images/icons/chevron-double-up.png');
export const doubleChevronDownIcon = require('@src/assets/images/icons/chevron-double-down.png');
export const filtersIcon = require('@src/assets/images/icons/filters-icon.svg').default;
export const filtersIconVertical = require('@src/assets/images/icons/filters-icon-vertical.svg').default;
export const lockIcon2 = require('@src/assets/images/icons/lock-icon-2.svg').default;
export const blockDotIcon = require('@src/assets/images/icons/black-dot.svg').default;
export const blackDotIcon = require('@src/assets/images/icons/black-dot.svg').default;
export const blockDownloadIcon = require('@src/assets/images/icons/black-download-icon.svg').default;

export const emptyResultsIcon = require('@src/assets/images/icons/empty-results.svg').default;
export const purpleLockIcon = require('@src/assets/images/icons/purple-lock.svg').default;
export const jobsCountV2Icon = require('@src/assets/images/icons/jobs-count-v2.svg').default;
export const fairUsageIcon = require('@src/assets/images/icons/fair-usage.svg').default;
export const finishedUnlocksIcon = require('@src/assets/images/icons/finished-unlocks.svg').default;
export const darkOrangeLockIcon = require('@src/assets/images/icons/dark-orange-lock.svg').default;

export const cvCloseIcon = require('@src/assets/images/icons/cv-close.svg').default;
export const cvFavoriteOutlineIcon = require('@src/assets/images/icons/cv-favorite-outline.svg').default;
export const cvFavoriteOrangeIcon = require('@src/assets/images/icons/cv-favorite-orange.svg').default;
export const cvReportIcon = require('@src/assets/images/icons/cv-report.svg').default;
export const cvFavoriteBlackIcon = require('@src/assets/images/icons/cv-favorite-black.svg').default;

export const jobs3Icon = require('@src/assets/images/icons/jobs-icon-3.svg').default;
export const purpleUnlockIcon = require('@src/assets/images/icons/purple-unlock.svg').default;
export const sampleCvs = require('@src/assets/images/icons/sample-cvs.png');
export const questionMarkCircleIcon = require('@src/assets/images/icons/question-mark-circle.svg').default;
export const orangeDotIcon = require('@src/assets/images/icons/orange-dot.svg').default;

export const newJpIcon = require('@src/assets/images/icons/new-jp.svg').default;
export const cloneJpIcon = require('@src/assets/images/icons/copy-jp.svg').default;
export const saudAiIcon = require('@src/assets/images/icons/saud-ai-icon.svg').default;
export const saudAiIconOutline = require('@src/assets/images/icons/ask-saud-green-outline.svg').default;

export const foundationBannerEn = require('@src/assets/images/icons/foundation-banner-en.png');
export const foundationBannerAr = require('@src/assets/images/icons/foundation-banner-ar.png');
export const foundationPopup = require('@src/assets/images/icons/foundation-popup.png');
export const foundationPlans = require('@src/assets/images/icons/foundation-plans.png');

export const vetFilterIcon = require('@src/assets/images/icons/vet-filter.svg').default;
export const greenDotIcon = require('@src/assets/images/icons/green-dot.svg').default;
export const greyDotIcon = require('@src/assets/images/icons/grey-dot.svg').default;
export const vettingLocation = require('@src/assets/images/icons/vetting-location.svg').default;
export const vettingSearch = require('@src/assets/images/icons/vet-search.svg').default;
export const pipeIcon = require('@src/assets/images/icons/pipe-icon.svg').default;
export const vetStar = require('@src/assets/images/icons/vet-shortist.svg').default;
export const vetReject = require('@src/assets/images/icons/vet-reject.svg').default;
export const vetWithSaud = require('@src/assets/images/icons/green-vetting.svg').default;
export const vetInvite = require('@src/assets/images/icons/vet-invite.svg').default;
export const emptyShortlistIcon = require('@src/assets/images/icons/empty-shortlist.svg').default;
export const emptyDetailsIcon = require('@src/assets/images/icons/empty-vetting.svg').default;
export const greenGlobeIcon = require('@src/assets/images/icons/green-globe.svg').default;
export const blackCheck = require('@src/assets/images/icons/black-check.svg').default;
export const linkIcon2 = require('@src/assets/images/icons/link-icon-2.svg').default;
export const linkIcon2Ar = require('@src/assets/images/icons/link-icon-2-ar.svg').default;
export const downloadIconOrange = require('@src/assets/images/icons/icon-download-orange.svg').default;
export const linkIcon3 = require('@src/assets/images/icons/link-icon-3.svg').default;
export const linkIcon3Ar = require('@src/assets/images/icons/link-icon-3-ar.svg').default;
export const linkIcon4 = require('@src/assets/images/icons/green-link-icon.svg').default;
export const linkIcon4Ar = require('@src/assets/images/icons/green-link-icon-ar.svg').default;
export const cashIcon = require('@src/assets/images/icons/dollar-icon.svg').default;
export const riyalIconBlack = require('@src/assets/images/icons/riyal-icon.svg').default;
export const riyalIconGrey = require('@src/assets/images/icons/riyal-icon-grey.svg').default;
export const riyalIconBlue = require('@src/assets/images/icons/riyal-icon-blue.svg').default;
export const riyalIconGreen = require('@src/assets/images/icons/riyal-icon-green.svg').default;
export const riyalIconGreen2 = require('@src/assets/images/icons/riyal-icon-green-2.svg').default;
export const saudAvatar = require('@src/assets/images/icons/saud-avatar.svg').default;
export const saudAvatar2 = require('@src/assets/images/icons/saud-avatar-2.png');
export const saudAvatar3 = require('@src/assets/images/icons/saud-modal.jpeg');

export const saudInterviewIcon = require('@src/assets/images/icons/saud-interview.svg').default;
export const aiThumbsUp = require('@src/assets/images/icons/ai-thumbs-up.svg').default;
export const aiThumbsDown = require('@src/assets/images/icons/ai-thumbs-down.svg').default;
export const aiFire = require('@src/assets/images/icons/ai-fire.svg').default;
export const aiBriefcase = require('@src/assets/images/icons/ai-briefcase.svg').default;
export const whiteCloseIcon = require('@src/assets/images/icons/white-close.svg').default;
export const saudMic = require('@src/assets/images/icons/saud-mic.svg').default;
export const saudEmoji = require('@src/assets/images/icons/saud-emoji.svg').default;
export const greenCheck2 = require('@src/assets/images/icons/green-check-2.svg').default;
export const dashIcon = require('@src/assets/images/icons/dash-icon.svg').default;

export const comapnyLogo1 = require('@src/assets/images/lp/t1.png');
export const comapnyLogo2 = require('@src/assets/images/lp/t2.png');
export const comapnyLogo3 = require('@src/assets/images/lp/t3.png');
export const comapnyLogo4 = require('@src/assets/images/lp/t4.png');
export const comapnyLogo5 = require('@src/assets/images/lp/t5.png');
export const testimonial1Icon = require('@src/assets/images/avatars/testimonial-1.png');
export const testimonial2Icon = require('@src/assets/images/avatars/testimonial-2.png');
export const resultSuccessIcon = require('@src/assets/images/icons/result-success-icon.svg').default;
export const resultFailIcon = require('@src/assets/images/icons/result-fail-icon.svg').default;

export const thumbsUpIcon2 = require('@src/assets/images/icons/thumbs-up.svg').default;
export const thumbsDownIcon2 = require('@src/assets/images/icons/thumbs-down.svg').default;
export const longPipeIcon = require('@src/assets/images/icons/long-pipe.svg').default;
export const newWarningIcon = require('@src/assets/images/icons/new-warning.svg').default;
export const newWarningRedIcon = require('@src/assets/images/icons/new-warning-red.svg').default;
export const eidImg = require('@src/assets/images/icons/eid-img.png');
export const navPipe = require('@src/assets/images/icons/nav-pipe.svg').default;
export const one = require('@src/assets/images/icons/one.svg').default;
export const two = require('@src/assets/images/icons/two.svg').default;
export const play4 = require('@src/assets/images/icons/play4.svg').default;
export const noTemplates = require('@src/assets/images/icons/no-templates.svg').default;
export const entClock = require('@src/assets/images/icons/ent-clock.svg').default;
export const entMoney = require('@src/assets/images/icons/ent-money.svg').default;
export const entWorkplace = require('@src/assets/images/icons/ent-workplace.svg').default;
export const invalidInvitation = require('@src/assets/images/icons/invalid-invitation.svg').default;
export const invalidInvitation2 = require('@src/assets/images/icons/invalid-invitation.png');
export const infoBlue = require('@src/assets/images/icons/info-icon-blue.svg').default;
export const infoGrey = require('@src/assets/images/icons/info-icon-grey.svg').default;
export const entBriefcase = require('@src/assets/images/icons/ent-briefcase.svg').default;
export const entUsers = require('@src/assets/images/icons/ent-users.svg').default;
export const entSaud = require('@src/assets/images/icons/ent-saud.svg').default;
export const lightGreyDot = require('@src/assets/images/icons/light-grey-dot.svg').default;
export const lightGreenDot = require('@src/assets/images/icons/light-green-dot.svg').default;
export const docIcon = require('@src/assets/images/icons/doc-icon.svg').default;
export const infoIconBlack = require('@src/assets/images/icons/info-icon-black.svg').default;
export const infoIconDarkRed = require('@src/assets/images/icons/info-dark-red.svg').default;
export const orangeTrashIcon = require('@src/assets/images/icons/orange-trash.svg').default;
export const locationIconBig = require('@src/assets/images/icons/location-icon-big.svg').default;
export const saudLockIcon = require('@src/assets/images/icons/saud-lock.svg').default;

export const archiveJobIcon = require('@src/assets/images/icons/archive-job.svg').default;
export const copyJobIcon = require('@src/assets/images/icons/copy-job.svg').default;
export const entBillingIcon = require('@src/assets/images/icons/ent-billing.svg').default;
export const entDefaultLogoIcon = require('@src/assets/images/icons/ent-default-logo.svg').default;
export const entGlobeIcon = require('@src/assets/images/icons/ent-globe.svg').default;
export const entProfileIcon = require('@src/assets/images/icons/ent-profile.svg').default;
export const entTeamIcon = require('@src/assets/images/icons/ent-team.svg').default;
export const logoutIcon = require('@src/assets/images/icons/logout.svg').default;
export const reopenJobIcon2 = require('@src/assets/images/icons/reopen-job-2.svg').default;
export const switchAccountsIcon = require('@src/assets/images/icons/switch-accounts.svg').default;
export const unArchiveJobIcon = require('@src/assets/images/icons/unarchive-job.svg').default;
export const closeJobIcon = require('@src/assets/images/icons/close-job.svg').default;
export const backToAppliedIcon = require('@src/assets/images/icons/back-to-applied.svg').default;

export const basicPlanIcon = require('@src/assets/images/icons/basic-icon.svg').default;
export const premiumPlanIcon = require('@src/assets/images/icons/premium-icon.svg').default;
export const enterprisePlanIcon = require('@src/assets/images/icons/enterprise-icon.svg').default;
export const extraJobIcon = require('@src/assets/images/icons/extra-job-icon.svg').default;
export const extrasIcon = require('@src/assets/images/icons/extras.svg').default;
export const visibilityIcon = require('@src/assets/images/icons/visibility-icon.svg').default;
export const visibilityIconAr = require('@src/assets/images/icons/visibility-icon-ar.svg').default;
export const orangeArrowDown = require('@src/assets/images/icons/arrow-down.svg').default;
export const newCheck = require('@src/assets/images/icons/new-check.svg').default;
export const newClose = require('@src/assets/images/icons/new-close.svg').default;
export const ent1Icon = require('@src/assets/images/icons/ent1.png');
export const ent2Icon = require('@src/assets/images/icons/ent2.png');
export const ent3Icon = require('@src/assets/images/icons/ent3.png');
export const ent4Icon = require('@src/assets/images/icons/ent4.png');

export const basicBlack = require('@src/assets/images/icons/basic-black.svg').default;
export const basicOrange = require('@src/assets/images/icons/basic-orange.svg').default;
export const premiumBlack = require('@src/assets/images/icons/premium-black.svg').default;
export const premiumOrange = require('@src/assets/images/icons/premium-orange.svg').default;
export const blackClose = require('@src/assets/images/icons/black-close.svg').default;
export const circleLock = require('@src/assets/images/icons/circle-lock.svg').default;
export const circlePlay = require('@src/assets/images/icons/circle-play.svg').default;
export const enterpriseBlack = require('@src/assets/images/icons/enterprise-black.svg').default;
export const enterpriseOrange = require('@src/assets/images/icons/enterprise-orange.svg').default;
export const feature1Icon = require('@src/assets/images/icons/feature-1-icon.svg').default;
export const feature2Icon = require('@src/assets/images/icons/feature-2-icon.svg').default;
export const feature3Icon = require('@src/assets/images/icons/feature-3-icon.svg').default;
export const feature4Icon = require('@src/assets/images/icons/feature-4-icon.svg').default;
export const feature5Icon = require('@src/assets/images/icons/feature-5-icon.svg').default;
export const feature6Icon = require('@src/assets/images/icons/feature-6-icon.svg').default;
export const feature7Icon = require('@src/assets/images/icons/feature-7-icon.svg').default;
export const featuredIcon = require('@src/assets/images/icons/featured-icon.svg').default;
export const fullInterview = require('@src/assets/images/icons/full-interview.svg').default;
export const goodFitIcon = require('@src/assets/images/icons/good-fit.svg').default;
export const maybeIcon = require('@src/assets/images/icons/maybe.svg').default;
export const mismatchIcon = require('@src/assets/images/icons/mismatch.svg').default;
export const promotionIcon = require('@src/assets/images/icons/promotion-icon.svg').default;
export const purpleLock2Icon = require('@src/assets/images/icons/purple-lock-2.svg').default;
export const redDotIcon = require('@src/assets/images/icons/red-dot.svg').default;
export const saudCard = require('@src/assets/images/icons/saud-card.png');
export const saudSabbar = require('@src/assets/images/icons/saud-sabbar.png');
export const saudSquarish = require('@src/assets/images/icons/saud-squarish.png');
export const smallPhoneIcon = require('@src/assets/images/icons/small-phone.svg').default;
export const smallPlayIcon = require('@src/assets/images/icons/small-play.svg').default;
export const smallPlayOrangeIcon = require('@src/assets/images/icons/small-play-orange.svg').default;
export const wantMoreIcon = require('@src/assets/images/icons/want-more.svg').default;
export const watchSaudIcon = require('@src/assets/images/icons/watch-saud.png');
export const watchSaudArIcon = require('@src/assets/images/icons/watch-saud-ar.png');
export const whiteArrowUp = require('@src/assets/images/icons/white-arrow-up.svg').default;
export const whiteLock = require('@src/assets/images/icons/white-lock.svg').default;
export const minus3Icon = require('@src/assets/images/icons/minus-3.svg').default;
export const plus3Icon = require('@src/assets/images/icons/plus-3.svg').default;
export const orangeLock = require('@src/assets/images/icons/orange-lock.svg').default;
export const whiteRocket = require('@src/assets/images/icons/white-rocket.svg').default;
export const whiteBoostUp = require('@src/assets/images/icons/white-boost-up.svg').default;
export const fileIcon = require('@src/assets/images/icons/file-icon.svg').default;
export const unlockedIcon = require('@src/assets/images/icons/unlocked-icon.svg').default;
export const outlineLock = require('@src/assets/images/icons/outline-lock.svg').default;
export const blurredProfile = require('@src/assets/images/icons/blurred-profile.png');
export const successPayment2 = require('@src/assets/images/icons/success-payment-2.svg').default;
export const emptyFilters = require('@src/assets/images/icons/empty-filters-3.svg').default;
export const rocket3 = require('@src/assets/images/icons/rocket-3.svg').default;
export const enterpriseVideoThumbnail = require('@src/assets/images/icons/enterprise-video-thumbnail.png');
export const whatsappOrange = require('@src/assets/images/icons/whatsapp-orange.svg').default;
export const emptyVideo2 = require('@src/assets/images/icons/empty-video-2.png');
export const maintenanceImg = require('@src/assets/images/icons/under-maintenance.png');
export const lockedAccount = require('@src/assets/images/icons/locked-account.svg').default;
export const emptyJobList = require('@src/assets/images/icons/empty-job-list.png');
export const greyThumbsDown = require('@src/assets/images/icons/grey-thumbs-down.svg').default;
export const yelloMaybe = require('@src/assets/images/icons/yellow-maybe.svg').default;
export const greenThumbsUp = require('@src/assets/images/icons/green-thumbs-up.svg').default;
export const interviewedIcon = require('@src/assets/images/icons/interviewed.svg').default;
export const bulkMessageIcon = require('@src/assets/images/icons/bulk-messge.svg').default;
export const nationalLogo = require('@src/assets/images/icons/national-logo.svg').default;
export const ndEmblem = require('@src/assets/images/pricing/national-day/nd-emblem.png');
export const riyalWhite = require('@src/assets/images/icons/riyal-icon-white.png');
export const triangleWarning = require('@src/assets/images/icons/triangle-warning.svg').default;
export const contractType2Icon = require('@src/assets/images/icons/contract-type-2.svg').default;
export const interviewFinishedIcon = require('@src/assets/images/icons/interview-finished.svg').default;
export const interviewDeclinedIcon = require('@src/assets/images/icons/interview-declined.svg').default;



export const shareBlackIcon = require('@src/assets/images/icons/share-black.svg').default;
export const shareOrangeIcon = require('@src/assets/images/icons/share-orange.svg').default;
export const whatsapp2Icon = require('@src/assets/images/icons/whatsapp-2.svg').default;
export const linkedin2Icon = require('@src/assets/images/icons/linkedin-2.svg').default;
export const x2Icon = require('@src/assets/images/icons/x-2.svg').default;
export const tiktok2Icon = require('@src/assets/images/icons/tiktok-2.svg').default;
export const instagram2Icon = require('@src/assets/images/icons/instagram-2.svg').default;
export const qrIcon = require('@src/assets/images/icons/qr-icon.svg').default;
export const copy2Icon = require('@src/assets/images/icons/copy2-icon.svg').default;

export const whatsapp5Icon = require('@src/assets/images/icons/whatsapp-icon-5.svg').default;
export const mobile5Icon = require('@src/assets/images/icons/mobile-icon-5.svg').default;
export const email5Icon = require('@src/assets/images/icons/email-icon-5.svg').default;

export const oneTimeHiringIcon = require('@src/assets/images/icons/one-time-hiring.svg').default;
export const alwaysHiringIcon = require('@src/assets/images/icons/always-hiring.svg').default;
export const addStageIcon = require('@src/assets/images/icons/add-stage.svg').default;
export const cardViewIcon = require('@src/assets/images/icons/card-view.svg').default;
export const downButtonIcon = require('@src/assets/images/icons/down-button.svg').default;
export const filterIcon3Icon = require('@src/assets/images/icons/filter-icon-3.svg').default;
export const newRejectIcon = require('@src/assets/images/icons/new-reject.svg').default;
export const newShortlistIcon = require('@src/assets/images/icons/new-shortlist.svg').default;
export const nextStageIcon = require('@src/assets/images/icons/next-stage.svg').default;
export const noApplicantsIcon = require('@src/assets/images/icons/no-applicants.svg').default;
export const noLocationIcon = require('@src/assets/images/icons/no-location.svg').default;
export const noResultsIcon = require('@src/assets/images/icons/no-results.svg').default;
export const oneStepIcon = require('@src/assets/images/icons/one-step.svg').default;
export const orangeVerticalLineIcon = require('@src/assets/images/icons/orange-vertical-line.svg').default;
export const greyVerticalLineIcon = require('@src/assets/images/icons/grey-2-vertical-line.svg').default;
export const recAppliedIcon = require('@src/assets/images/icons/rec-applied.svg').default;
export const recHiredIcon = require('@src/assets/images/icons/rec-hired.svg').default;
export const recHrInterviewIcon = require('@src/assets/images/icons/rec-hr-interview.svg').default;
export const recInterviewedIcon = require('@src/assets/images/icons/rec-interviewed.svg').default;
export const recOfferIcon = require('@src/assets/images/icons/rec-offer.svg').default;
export const recruitmentStepIcon = require('@src/assets/images/icons/recruitment-step.svg').default;
export const searchIcon3Icon = require('@src/assets/images/icons/search-icon-3.svg').default;
export const stepCompletedIcon = require('@src/assets/images/icons/step-completed.svg').default;
export const tableViewIcon = require('@src/assets/images/icons/table-view.svg').default;
export const threeStepIcon = require('@src/assets/images/icons/three-step.svg').default;
export const twoStepIcon = require('@src/assets/images/icons/two-step.svg').default;
export const fourStepIcon = require('@src/assets/images/icons/four-step.svg').default;
export const fiveStepIcon = require('@src/assets/images/icons/five-step.svg').default;
export const upButtonIcon = require('@src/assets/images/icons/up-button.svg').default;
export const xButtonIcon = require('@src/assets/images/icons/x-button.svg').default;
export const closeIcon5 = require('@src/assets/images/icons/close-icon-5.svg').default;
export const draggableIcon = require('@src/assets/images/icons/draggable.svg').default;
export const pencilIcon = require('@src/assets/images/icons/pencil.svg').default;
export const trashIcon = require('@src/assets/images/icons/trash.svg').default;
export const plusIcon = require('@src/assets/images/icons/white-plus.svg').default;
export const backLeftIcon = require('@src/assets/images/icons/vet-back-en.svg').default;
export const backRightIcon = require('@src/assets/images/icons/vet-back-ar.svg').default;
export const manageJobIcon = require('@src/assets/images/icons/manage-job.svg').default;
export const locationIcon2 = require('@src/assets/images/icons/location-icon-2.svg').default;

export const offlineIcon = require('@src/assets/images/icons/career-website.svg').default;
export const whatsappWhiteIcon = require('@src/assets/images/icons/whatsapp-white.svg').default;

export const careerWebsiteIcon = require('@src/assets/images/icons/career-website.svg').default;
export const sourceLinkedinIcon = require('@src/assets/images/icons/source-linkedin.svg').default;
export const sourceBaytIcon = require('@src/assets/images/icons/source-bayt.svg').default;
export const sourceGoogleIcon = require('@src/assets/images/icons/source-google.svg').default;
export const sourceIndeedIcon = require('@src/assets/images/icons/source-indeed.svg').default;
export const sourceNaukriGulfIcon = require('@src/assets/images/icons/source-naukri-gulf.svg').default;
export const sourceGlassdoorIcon = require('@src/assets/images/icons/source-glassdoor.svg').default;
export const sourceMonsterGulfIcon = require('@src/assets/images/icons/source-monster-gulf.svg').default;
export const sourceGulfTalentIcon = require('@src/assets/images/icons/source-gulf-talent.svg').default;
export const sourceFacebookIcon = require('@src/assets/images/icons/source-facebook.svg').default;
export const sourceTwitterIcon = require('@src/assets/images/icons/source-twitter.svg').default;
export const sourceInstagramIcon = require('@src/assets/images/icons/source-instagram.svg').default;
export const sourceSnapchatIcon = require('@src/assets/images/icons/source-snapchat.svg').default;
export const sourceWhatsappIcon = require('@src/assets/images/icons/source-whatsapp.svg').default;
export const sourceTelegramIcon = require('@src/assets/images/icons/source-telegram.svg').default;
export const sourceTiktokIcon = require('@src/assets/images/icons/source-tiktok.svg').default;

export const blackCheckIcon = require('@src/assets/images/icons/black-check.svg').default;
export const blackClose2Icon = require('@src/assets/images/icons/black-close-2.svg').default;
export const blackEditIcon = require('@src/assets/images/icons/black-edit.svg').default;
export const blackInterviewIcon = require('@src/assets/images/icons/black-interview.svg').default;
export const blackMsgIcon = require('@src/assets/images/icons/black-msg.svg').default;
export const blackNextArIcon = require('@src/assets/images/icons/black-next-ar.svg').default;
export const blackNextEnIcon = require('@src/assets/images/icons/black-next-en.svg').default;
export const blackStarIcon = require('@src/assets/images/icons/black-star.svg').default;
export const blackVideoIcon = require('@src/assets/images/icons/black-video.svg').default;
export const blackXIcon = require('@src/assets/images/icons/black-x.svg').default;
export const greenWhatsIcon = require('@src/assets/images/icons/green-whats.svg').default;
export const greenWhatsIcon2 = require('@src/assets/images/icons/green-whats-2.svg').default;
export const greyDeleteIcon = require('@src/assets/images/icons/grey-delete.svg').default;
export const greyEditIcon = require('@src/assets/images/icons/grey-edit.svg').default;
export const hasDisabilityIcon = require('@src/assets/images/icons/has-disability.svg').default;
export const hasInterviewIcon = require('@src/assets/images/icons/has-interview.svg').default;
export const hasVideo2Icon = require('@src/assets/images/icons/has-video-2.svg').default;
export const orangeOnlineIcon = require('@src/assets/images/icons/orange-online.svg').default;
export const publishIcon = require('@src/assets/images/icons/publish-icon.svg').default;
export const phoneBlackIcon = require('@src/assets/images/icons/phone-black.svg').default;
export const blackDeleteIcon = require('@src/assets/images/icons/black-delete.svg').default;
export const verified2Icon = require('@src/assets/images/icons/verified-2.svg').default;
export const newApplicantsIcon = require('@src/assets/images/icons/new-applicants.svg').default;
export const orangeCopyIcon = require('@src/assets/images/icons/orange-copy.svg').default;
export const infoDarkOrangeIcon = require('@src/assets/images/icons/info-dark-orange.svg').default;
export const noEditIcon = require('@src/assets/images/icons/no-edit.svg').default;
export const emojisIcon = require('@src/assets/images/icons/emojis-icon.svg').default;
export const knowledgeBaseIcon = require('@src/assets/images/icons/knowledge-base.svg').default;
export const smallBlackLockIcon = require('@src/assets/images/icons/small-black-lock.svg').default;

export const whatsappGreyTicks = require('@src/assets/images/icons/whatsapp-grey-ticks.svg').default;
export const whatsappGreenTicks = require('@src/assets/images/icons/whatsapp-green-ticks.svg').default;
// export const whatsappBlueTicks = require('@src/assets/images/icons/whatsapp-blue-ticks.svg').default;
export const noNumberIcon = require('@src/assets/images/icons/no-number.svg').default;

// Interview scheduling icons
export const interviewAppointmentsIcon = require('@src/assets/images/icons/small-calendar.svg').default;
export const noAppointmentsIcon = require('@src/assets/images/icons/no-appointments.svg').default;
export const blackCalendarIcon = require('@src/assets/images/icons/black-calendar.svg').default;
export const blackCancelIcon = require('@src/assets/images/icons/black-cancel.svg').default;
export const blueMarkerIcon = require('@src/assets/images/icons/blue-marker.svg').default;
export const blackMsgIcon2 = require('@src/assets/images/icons/black-msg-2.svg').default;
export const blueOnlineIcon = require('@src/assets/images/icons/blue-online.svg').default;
export const darkEditIcon = require('@src/assets/images/icons/dark-edit.svg').default;
export const darkInfoIcon = require('@src/assets/images/icons/dark-info.svg').default;
export const darkOrangePlusIcon = require('@src/assets/images/icons/dark-orange-plus.svg').default;
export const greenPassedIcon = require('@src/assets/images/icons/green-passed.svg').default;
export const greyDidntAttendIcon = require('@src/assets/images/icons/grey-didnt-attend.svg').default;
export const greyPendingIcon = require('@src/assets/images/icons/grey-pending.svg').default;
export const greyRejectedIcon = require('@src/assets/images/icons/grey-rejected.svg').default;
export const LightOrangePlusIcon = require('@src/assets/images/icons/light-orange-plus.svg').default;
export const DarkPlusIcon = require('@src/assets/images/icons/dark-plus.svg').default;
export const DarkSparkleIcon = require('@src/assets/images/icons/dark-sparkle.svg').default;
export const logIcon = require('@src/assets/images/icons/log-icon.svg').default;
export const noInterviewResultsIcon = require('@src/assets/images/icons/no-interview-results.svg').default;
export const noInterviewsIcon = require('@src/assets/images/icons/no-interviews.svg').default;
export const orangeBackIcon = require('@src/assets/images/icons/orange-back.svg').default;
export const redTrashIcon = require('@src/assets/images/icons/red-trash.svg').default;
export const modalCloseIcon = require('@src/assets/images/icons/modal-close.svg').default;
export const darkOrangeListIcon = require('@src/assets/images/icons/dark-orange-list.svg').default;
export const bubbleTriangleIcon = require('@src/assets/images/icons/bubble-triangle.svg').default;
export const bgPlusIcon = require('@src/assets/images/icons/bg-plus.svg').default;
export const largeInfoIcon = require('@src/assets/images/icons/large-info.svg').default;
export const onboardingFeatureAddIcon = require('@src/assets/images/icons/onboarding-feature-add.svg').default;
export const onboardingFeatureTasksIcon = require('@src/assets/images/icons/onboarding-feature-tasks.svg').default;
export const onboardingFeatureReviewIcon = require('@src/assets/images/icons/onboarding-feature-review.svg').default;

export const multipleInterviewsIcon = require('@src/assets/images/icons/multiple-interviews.svg').default;
export const upcomingInterviewIcon = require('@src/assets/images/icons/upcoming-interview.svg').default;
export const confirmedInterviewIcon = require('@src/assets/images/icons/confirmed-interview.svg').default;
export const pendingInterviewIcon = require('@src/assets/images/icons/pending-interview.svg').default;

export const interviewPassedIcon = require('@src/assets/images/icons/interview-passed.svg').default;
export const interviewDidntAttendIcon = require('@src/assets/images/icons/interview-didnt-attend.svg').default;
export const interviewRejectedIcon = require('@src/assets/images/icons/interview-rejected.svg').default;
export const interviewDeclineIcon = require('@src/assets/images/icons/interview-decline.svg').default;
export const interviewCanceledIcon = require('@src/assets/images/icons/interview-canceled.svg').default;
export const interviewExpiredIcon = require('@src/assets/images/icons/interview-expired.svg').default;

export const listDragIcon = require('@src/assets/images/icons/list-drag-icon.svg').default;
export const redDeleteIcon = require('@src/assets/images/icons/red-trash.svg').default;
export const greyEdit2Icon = require('@src/assets/images/icons/grey-edit.svg').default;
export const smNotesIcon = require('@src/assets/images/icons/sm-notes.svg').default;
export const onsiteBlackIcon = require('@src/assets/images/icons/onsite-icon-black.svg').default;
export const onlineBlackIcon = require('@src/assets/images/icons/online-icon-black.svg').default;
export const singleChoiceIcon = require('@src/assets/images/icons/single-choice.svg').default;

export const multipleChoicesIcon = require('@src/assets/images/icons/multiple-choices.svg').default;
export const shortTextIcon = require('@src/assets/images/icons/short-text.svg').default;
export const longTextIcon = require('@src/assets/images/icons/long-text.svg').default;
export const linkIcon = require('@src/assets/images/icons/link-icon.svg').default;
export const fileUploadIcon = require('@src/assets/images/icons/file-upload.svg').default;
export const videoUploadIcon = require('@src/assets/images/icons/video-upload.svg').default;
export const dragIcon = require('@src/assets/images/icons/drag-icon.svg').default;
export const chevronDownIcon = require('@src/assets/images/icons/chevron-down.svg').default;
export const chevronUpIcon = require('@src/assets/images/icons/chevron-up.svg').default;
export const radioIndicatorIcon = require('@src/assets/images/icons/radio-indicator.svg').default;
export const checkboxIndicatorIcon = require('@src/assets/images/icons/checkbox-indicator.svg').default;
export const bigSearchIcon = require('@src/assets/images/icons/big-search.svg').default;
export const whiteWarning = require('@src/assets/images/icons/white-warning.svg').default;
export const bulbAnswersIcon = require("@src/assets/images/icons/bulb-ai-answers.svg").default;

// Onboarding icons
export const clipGreyIcon = require("@src/assets/images/icons/clip-grey.svg").default;
export const closeGreyBgIcon = require("@src/assets/images/icons/close-grey-bg.svg").default;
export const dashBlackIcon = require("@src/assets/images/icons/dash-black.svg").default;
export const downloadGrey2Icon = require("@src/assets/images/icons/download-grey-2.svg").default;
export const downloadGreyBgIcon = require("@src/assets/images/icons/download-grey-bg.svg").default;
export const downloadIcon5 = require("@src/assets/images/icons/download-icon-5.svg").default;
export const downloadIcon6 = require("@src/assets/images/icons/download-icon-6.svg").default;
export const downloadIcon7 = require("@src/assets/images/icons/download-icon-7.svg").default;
export const downloadIcon8 = require("@src/assets/images/icons/download-icon-8.svg").default;
export const file3Icon = require("@src/assets/images/icons/file-3.svg").default;
export const greyCheck2Icon = require("@src/assets/images/icons/grey-check-2.svg").default;
export const menuIconBlack = require("@src/assets/images/icons/menu-icon-black.svg").default;
export const msg3Icon = require("@src/assets/images/icons/msg-3.svg").default;
export const noRes3Icon = require("@src/assets/images/icons/no-res-3.svg").default;
export const sendBgIcon = require("@src/assets/images/icons/send-bg.svg").default;
export const sendGreyIcon = require("@src/assets/images/icons/send-grey.svg").default;
export const sendIconBlack = require("@src/assets/images/icons/send-icon-black.svg").default;
export const upIconBlack = require("@src/assets/images/icons/up-icon-black.svg").default;
export const uploadGreyBgIcon = require("@src/assets/images/icons/upload-grey-bg.svg").default;
export const onboardingCsvPreview = require("@src/assets/images/icons/qiwa.png");
export const onboardingClockBgIcon = require("@src/assets/images/icons/onboarding-clock-bg.svg").default;
export const onboardingExpiredClockIcon = require("@src/assets/images/icons/onboarding-expired-clock.svg").default;
export const onboardingAdditionalInfoIcon = require("@src/assets/images/icons/onboarding-additional-info.svg").default;
export const onboardingUploadDocumentIcon = require("@src/assets/images/icons/onboarding-upload-document.svg").default;
export const onboardingFillFormIcon = require("@src/assets/images/icons/onboarding-fill-form.svg").default;
export const onboardingUploadDocumentActiveIcon = require("@src/assets/images/icons/onboarding-upload-document-active.svg").default;
export const onboardingFillFormActiveIcon = require("@src/assets/images/icons/onboarding-fill-form-active.svg").default;
export const onboardingAdditionalInfoActiveIcon = require("@src/assets/images/icons/onboarding-additional-info-active.svg").default;
export const onboardingTourEditIcon = require("@src/assets/images/icons/onboarding-tour-edit.svg").default;
export const onboardingTourUploadIcon = require("@src/assets/images/icons/onboarding-tour-upload.svg").default;
export const onboardingTourDocumentIcon = require("@src/assets/images/icons/onboarding-tour-document.svg").default;
export const onboardingHealthCardIcon = require("@src/assets/images/icons/onboarding-health-card.svg").default;
export const onboardingTaskTitleIcon = require("@src/assets/images/icons/onboarding-task-title.svg").default;
export const onboardingHealthCardActiveIcon = require("@src/assets/images/icons/onboarding-health-card-active.svg").default;
export const onboardingDeleteIcon = require("@src/assets/images/icons/onboarding-delete.svg").default;
export const onboardingEditIcon = require("@src/assets/images/icons/onboarding-edit.svg").default;
export const updateOnboardingStageIcon = require("@src/assets/images/icons/update-onboarding-stage.svg").default;
export const onboardingCloseIcon = require("@src/assets/images/icons/onboarding-close.svg").default;
export const onboardingQiwaContractIcon = require("@src/assets/images/icons/onboarding-qiwa-contract.svg").default;
export const onboardingDragIcon = require("@src/assets/images/icons/onboarding-drag.svg").default;
export const onboardingArrowUpIcon = require("@src/assets/images/icons/onboarding-arrow-up.svg").default;
export const onboardingQiwaPersonalIcon = require("@src/assets/images/icons/onboarding-qiwa-personal.svg").default;
export const onboardingQiwaAcademicIcon = require("@src/assets/images/icons/onboarding-qiwa-academic.svg").default;
export const onboardingQiwaAddressIcon = require("@src/assets/images/icons/onboarding-qiwa-address.svg").default;
export const onboardingQiwaBankIcon = require("@src/assets/images/icons/onboarding-qiwa-bank.svg").default;
export const greenCheck3 = require("@src/assets/images/icons/green-check-3.svg").default;

export const viewFullScreeningQuestionsIcon =
  require("@src/assets/images/icons/view-full-screening-question.svg").default;
export const deleteOptionScreeningQuestionIcon =
  require("@src/assets/images/icons/delete-option-screening-question.svg").default;
export const linkScreeningQuestionIcon = require("@src/assets/images/icons/link-icon-type.svg").default;
export const linkIconAnswerQuestionIcon =
  require("@src/assets/images/icons/link-icon.svg").default;

export const startOnboardingIcon = require("@src/assets/images/icons/start-onboarding.svg").default;
export const talentAcquisitionSyncIcon = require("@src/assets/images/icons/talent-acquisition-sync.svg").default;
export const actionsMenuIcon = require("@src/assets/images/icons/actions-menu.svg").default;
export const actionsDropdownArrowIcon = require("@src/assets/images/icons/actions-dropdown-arrow.svg").default;

// Onboarding completion status icons
export const onboardingCompleteIcon = require("@src/assets/images/icons/onboarding-complete.svg").default;
export const onboardingTaskCompleteIcon = require("@src/assets/images/icons/onboarding-task-complete.svg").default;
export const onboardingIncompleteIcon = require("@src/assets/images/icons/onboarding-incomplete.svg").default;

// Onboarding group collapse/expand icons
export const collapseGroupIcon = require("@src/assets/images/icons/collapse-group.svg").default;
export const expandGroupIcon = require("@src/assets/images/icons/expand-group.svg").default;

// Onboarding header actions dropdown icons
export const onboardingMoreHorizontalIcon = require("@src/assets/images/icons/onboarding-more-horizontal.svg").default;
export const onboardingResendRequestIcon = require("@src/assets/images/icons/onboarding-resend-request.svg").default;
export const onboardingCancelRequestIcon = require("@src/assets/images/icons/onboarding-cancel-request.svg").default;
export const onboardingExportQiwaIcon = require("@src/assets/images/icons/onboarding-export-qiwa.svg").default;
export const onboardingDownloadAttachmentsIcon = require("@src/assets/images/icons/onboarding-download-attachments.svg").default;
export const onboardingAttachmentIcon = require("@src/assets/images/icons/onboarding-attachment.svg").default;
export const onboardingRecollectIcon = require("@src/assets/images/icons/onboarding-recollect.svg").default;
export const onboardingRecollectPendingIcon = require("@src/assets/images/icons/onboarding-recollect-pending.svg").default;
export const onboardingStatusCheckIcon = require("@src/assets/images/icons/onboarding-status-check.svg").default;
export const onboardingDownloadFileIcon = require("@src/assets/images/icons/onboarding-download-file.svg").default;
export const onboardingLightningIcon = require("@src/assets/images/icons/onboarding-lightning.svg").default;
export const onboardingLinkIcon = require("@src/assets/images/icons/onboarding-link.svg").default;
export const searchGreyIcon = require("@src/assets/images/icons/search-grey.svg").default;

export const copyNameIcon = require("@src/assets/images/icons/copy-name-icon.svg").default;

export const onboardingEmptyStateIcon = require('@src/assets/images/icons/onboarding-empty-state-icon.svg').default;

export const errorIcon = require('@src/assets/images/icons/circle-red-alert.svg').default;
export const warning3Icon = require('@src/assets/images/icons/circle-orange-warning.svg').default;
export const whiteTrashIcon = require('@src/assets/images/icons/white-trash.svg').default;
export const madaLogo1Icon = require('@src/assets/images/icons/mada-1.webp');
export const greyDashIcon = require('@src/assets/images/icons/grey-dash.svg').default;
export const purpleBoltIcon = require('@src/assets/images/icons/purple-bolt.svg').default;
export const greenBoltIcon = require('@src/assets/images/icons/green-bolt.svg').default;
export const greenSaudIcon = require('@src/assets/images/icons/green-saud.svg').default;
export const blackSaudIcon = require('@src/assets/images/icons/black-saud.svg').default;
export const blackFireIcon = require('@src/assets/images/icons/black-fire.svg').default;
export const darkGreenDiscountIcon = require('@src/assets/images/icons/dark-green-discount.svg').default;
export const saudModalAvatar = require('@src/assets/images/icons/saud-modal-avatar.jpeg');
export const redDashIcon = require('@src/assets/images/icons/red-dash.svg').default;
export const whitePhoneIcon2 = require('@src/assets/images/icons/white-phone-2.svg').default;
export const goldCalendar = require('@src/assets/images/icons/nd-calendar.svg').default;
export const ndPlanBasicWhiteIcon = require('@src/assets/images/icons/nd-plan-basic-white.svg').default;
export const ndPlanPremWhiteIcon = require('@src/assets/images/icons/nd-plan-prem-white.svg').default;
export const ndPlanStarWhiteIcon = require('@src/assets/images/icons/nd-plan-star-white.svg').default;

